import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';
import { periodicidadeAnual } from '../../../shared';
import { isVisualizacaoModoList } from '../../../common/visualizacao-modo';
import { isPerspectivaMeta, isPerspectivaRAP } from '../perspectivas/cliente-analise-mercado-perspectiva';
import { clienteCadastroProspect, clienteCadastroCliente } from '../../pessoa/cliente/cadastro';
import { Cidade } from '../../cidade';

export class ClienteAnaliseMercadoFilter implements Filter {
    isFilterDirty = false;

    /** Modo de visualização da análise de mercado */
    visualizacaoModo: number;
    /** Perspectiva da visualização da análise de mercado */
    visualizacaoPerspectiva: number;

    // Periodicidade
    periodicidade = periodicidadeAnual.id;
    periodicidadeAtual = false;
    /** Periodicidade atualmente selecionada no datepicker */
    periodicidadeSelecionada: number;
    data: Date;
    mes: number;
    trimestre: number;
    semestre: number;
    ano: number;

    idCliente: number;
    filterPsq: string;

    // Status Pretendidos
    statusPretendidos: number[] = [];
    // Status Projetados
    statusProjetados: number[] = [];

    cadastrosClientes: number[] = [];
    situacoesClientes: number[] = [];
    idsClassificacoesClientes: number[] = [];
    classificacaoClienteNull = false;
    idsClientesTipos: number[] = [];
    idsClientesGrupos: number[] = [];
    idsClientesGruposEconomicos: number[] = [];
    idsClassificacoesRAP: number[] = [];
    indicadoresCustomerShareRAP: number[] = [];
    indicadoresCustomerShareRAR: number[] = [];
    idsItensTiposClientes: number[] = [];
    idsEstadosClientes: number[] = [];
    idCidadeCliente: number;
    cidadeCliente: Cidade;
    idsCidadesSubRegioesClientes: number[] = [];
    idsCidadesSubRegioesBairrosClientes: number[] = [];
    idsRepresentantes: number[] = [];
    somenteRepresentantesAtivos = true;
    idsAtendentes: number[] = [];
    idsGruposClassificacoes: number[] = [];
    idsClassificacoes: number[] = [];
    classificacaoNull = false;
    idsMetas: number[] = [];
    idMeta: number = null;

    constructor() {
        this.setDefaultFilters();
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade
        if (this.periodicidade) {
            params = params.append('periodicidade', this.periodicidade.toString());
        }
        // Periodicidade Atual
        if (this.periodicidadeAtual) {
            params = params.append('periodicidadeAtual', this.periodicidadeAtual.toString());
        }
        // Mês
        if (this.mes) {
            params = params.append('mes', this.mes.toString());
        }
        // Trimestre
        if (this.trimestre) {
            params = params.append('trimestre', this.trimestre.toString());
        }
        // Semestre
        if (this.semestre) {
            params = params.append('semestre', this.semestre.toString());
        }
        // Ano
        if (this.ano) {
            params = params.append('ano', this.ano.toString());
        }

        // Cliente
        if (this.idCliente) {
            params = params.append('idCliente', this.idCliente.toString());
        }
        // Filtro de Pesquisa
        if (isVisualizacaoModoList(this.visualizacaoModo) && this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        } else {
            params = params.delete('filterPsq');
        }

        // Cadastros dos clientes
        if (this.cadastrosClientes?.length > 0) {
            this.cadastrosClientes.forEach(cadastroCliente => {
                params = params.append('cadastroCliente', cadastroCliente.toString());
            });
        }
        // Situações dos clientes
        if (this.situacoesClientes?.length > 0) {
            this.situacoesClientes.forEach(situacaoCliente => {
                params = params.append('situacaoCliente', situacaoCliente.toString());
            });
        }

        // Classificações de clientes
        this.idsClassificacoesClientes?.forEach(idClassificacaoCliente => {
            if (idClassificacaoCliente > 0) {
                params = params.append('idClassificacaoCliente', idClassificacaoCliente.toString());
            }
        });
        // Sem classificação
        if (this.classificacaoClienteNull) {
            params = params.append('classificacaoClienteNull', 'true');
        }

        // Tipos de clientes
        if (this.idsClientesTipos?.length > 0) {
            this.idsClientesTipos.forEach(idClienteTipo => {
                params = params.append('idClienteTipo', idClienteTipo.toString());
            });
        }
        // Grupos dos Clientes
        if (this.idsClientesGrupos && this.idsClientesGrupos.length > 0) {
            this.idsClientesGrupos.forEach(idClienteGrupo => {
                params = params.append('idClienteGrupo', idClienteGrupo.toString());
            });
        }
        // Grupos Econômicos dos Clientes
        if (this.idsClientesGruposEconomicos && this.idsClientesGruposEconomicos.length > 0) {
            this.idsClientesGruposEconomicos.forEach(idClienteGrupoEconomico => {
                params = params.append('idClienteGrupoEconomico', idClienteGrupoEconomico.toString());
            });
        }
        // Tipos de itens dos clientes
        if (this.idsItensTiposClientes?.length > 0) {
            this.idsItensTiposClientes.forEach(idItemTipoCliente => {
                params = params.append('idItemTipoCliente', idItemTipoCliente.toString());
            });
        }
        // Estados dos clientes
        if (this.idsEstadosClientes?.length > 0) {
            this.idsEstadosClientes.forEach(idEstadoCliente => {
                params = params.append('idEstadoCliente', idEstadoCliente.toString());
            });
        }
        // Cidades dos clientes
        if (this.idCidadeCliente) {
            params = params.append('idCidadeCliente', this.idCidadeCliente.toString());
        }
        // Subregiões das cidades dos clientes
        if (this.idsCidadesSubRegioesClientes?.length > 0) {
            this.idsCidadesSubRegioesClientes.forEach(idCidadeSubRegiaoCliente => {
                params = params.append('idCidadeSubRegiaoCliente', idCidadeSubRegiaoCliente.toString());
            });
        }
        // Bairros das subregiões das cidades dos clientes
        if (this.idsCidadesSubRegioesBairrosClientes?.length > 0) {
            this.idsCidadesSubRegioesBairrosClientes.forEach(idCidadeSubRegiaoBairroCliente => {
                params = params.append('idCidadeSubRegiaoBairroCliente', idCidadeSubRegiaoBairroCliente.toString());
            });
        }

        // Representantes
        if (this.idsRepresentantes?.length > 0) {
            this.idsRepresentantes.forEach(id => {
                params = params.append('idRepresentante', id.toString());
            });
        }

        // Atendentes
        this.idsAtendentes?.forEach(idAtendente => {
            params = params.append('idAtendente', idAtendente.toString());
        });

        // Perspectiva
        if (this.visualizacaoPerspectiva) {
            params = params.append('perspectiva', this.visualizacaoPerspectiva.toString());
        }

        // Classificações RAP
        this.idsClassificacoesRAP?.forEach(idClassificacaoRAP => params = params.append('idClassificacaoRAP', idClassificacaoRAP.toString()));

        // Indicadores Customer Share RAP
        this.indicadoresCustomerShareRAP?.forEach(indicadorCustomerShareRAP => params = params.append('indicadorCustomerShareRAP', indicadorCustomerShareRAP.toString()));

        // Indicadores Customer Share RAR
        this.indicadoresCustomerShareRAR?.forEach(indicadorCustomerShareRAR => params = params.append('indicadorCustomerShareRAR', indicadorCustomerShareRAR.toString()));

        // Perspectiva Meta
        if (isPerspectivaMeta(this.visualizacaoPerspectiva)) {
            // Metas
            if (isVisualizacaoModoList(this.visualizacaoModo) && this.idMeta) { // Única meta quando for na perspectiva de Meta
                params = params.append('idMeta', this.idMeta.toString());
            } else {
                params = params.delete('idMeta');
            }
        } else {
            // Grupos de Classificações
            this.idsGruposClassificacoes?.forEach(idGrupoClassificacao => params = params.append('idGrupoClassificacao', idGrupoClassificacao.toString()));

            // Classificações de itens
            if (isVisualizacaoModoList(this.visualizacaoModo)) {
                this.idsClassificacoes?.forEach(idClassificacao => {
                    if (idClassificacao > 0) {
                        params = params.append('idClassificacao', idClassificacao.toString());
                    }
                });
                // Sem classificação
                if (this.classificacaoNull) {
                    params = params.append('classificacaoNull', 'true');
                }
            } else {
                params = params.delete('idClassificacao')
                                .delete('classificacaoNull');
            }
        }

        // Status Pretendidos
        this.statusPretendidos?.forEach(statusPretendido => {
            params = params.append('statusPretendido', statusPretendido.toString());
        });

        // Status Projetados
        this.statusProjetados?.forEach(statusProjetado => {
            params = params.append('statusProjetado', statusProjetado.toString());
        });

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.idCliente = null;
        this.filterPsq = null;
        this.statusPretendidos = [];
        this.statusProjetados = [];
        this.cadastrosClientes = [];
        this.situacoesClientes = [];
        this.idsClassificacoesClientes = [];
        this.classificacaoClienteNull = false;
        this.idsClientesTipos = [];
        this.idsClientesGrupos = [];
        this.idsClientesGruposEconomicos = [];
        this.idsClassificacoesRAP = [];
        this.indicadoresCustomerShareRAP = [];
        this.indicadoresCustomerShareRAR = [];
        this.idsItensTiposClientes = [];
        this.idsEstadosClientes = [];
        this.idCidadeCliente = null;
        this.cidadeCliente = null;
        this.idsCidadesSubRegioesClientes = [];
        this.idsCidadesSubRegioesBairrosClientes = [];
        this.idsRepresentantes = [];
        this.idsAtendentes = [];
        this.somenteRepresentantesAtivos = true;
        this.idsGruposClassificacoes = [];
        this.idsClassificacoes = [];
        this.classificacaoNull = false;
        this.idsMetas = [];
        this.idMeta = null;

        this.setDefaultFilters();
    }

    /** Seta os filtros padrões */
    setDefaultFilters() {
        this.cadastrosClientes = [clienteCadastroProspect.id,clienteCadastroCliente.id]; // Prospects e Clientes
    }

    /** Verifica se o filtro possui o ano */
    possuiAno(): boolean {
        if (!this.data) {
            return false;
        }
        if (!this.ano) {
            return false;
        }
        return true;
    }

    /** Verifica se possui um único grupo de classificação selecionado */
    private possuiGrupoClassificacaoSelecionado(): boolean {
        return this.idsGruposClassificacoes?.length === 1;
    }

    /** Obtem o ID do grupo de classificação quando tiver somente um único grupo selecionado */
    getGrupoClassificacaoSelecionado(): number {
        if (!this.possuiGrupoClassificacaoSelecionado()) {
            return null;
        }
        return this.idsGruposClassificacoes[0];
    }
}
